import { h } from 'preact';
import clsx from 'clsx';
import { formatMoney } from '../utils/helpers';
import Gift from '../utils/icon/gift.svg';

const Price = ({
  currentPrice = { amount: 0, currencyCode: window.TMW?.localization?.currencyCode  || 'USD' },
  currentComparePrice,
  fontClass,
  customContainerClass,
  comparePriceColor = '!text-grey-60',
  customPromotions,
  compareAtPriceBadge,
  isGWP = false,
  cents = false,
  promoFlag
}) => (
  <div
    className={clsx(
      'justify-start flex gap-2.5 items-center ',
      customContainerClass,
      isGWP && '!gap-2 !flex-row',
    )}
  >
    {isGWP && <Gift />}
    {currentPrice?.amount && (
      <span className={clsx(fontClass, isGWP && 'line-through !text-grey-60')}>
        {formatMoney(currentPrice, cents)}
      </span>
    )}
    {compareAtPriceBadge === 'true' && currentComparePrice ? (
      <div className="px-[6px] pt-[3px] pb-[5px] bg-peach utility-2 uppercase rounded-[3px]">
        {TMW.Strings.product.comparePriceValueBadge.replace(
          '{{ price }}',
          formatMoney(currentComparePrice, cents),
        )}
      </div>
    ) : (
      currentComparePrice &&
      !isGWP && (
        <del className={clsx(fontClass, comparePriceColor)}>
          {formatMoney(currentComparePrice, cents)}
        </del>
      )
    )}
    {customPromotions === 'true' && (
      <div className="px-[6px] pt-[3px] pb-[5px] bg-white utility-2 uppercase rounded-[3px]">
        {TMW.Strings.product.promotions}
      </div>
    )}
    {promoFlag && (
      <span className='block w-fit py-1 px-1.5 text-[11px] font-gotham bg-[#DBE3D1] rounded-[3px] leading-[1]'>{promoFlag}</span>
    )}
  </div>
);

export default Price;
